<script>
import Button from "../../../../theme/atoms/BasicButton.vue";

export default {
    name: "LoginCandidateWide",
    props: {
        candidate: {
            type: Object,
            required: true
        },
        isEmailLinked: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Button,
        avatarImage: () => import("../../../../theme/atoms/AvatarImage.vue"),
    },
    computed: {
        secondIdentifier() {
            if (this.isEmailLinked) {
                return this.candidate?.space?.name ?? this.candidate.email;
            }

            return this.candidate.email;
        },
        spaceImage() {
            if (this.candidate?.space?.image) {
                return this.candidate.space.image.absolute_path;
            }

            return null;
        },
        image() {
            return this.candidate?.image?.sizes?.md ?? '/img/avatar.png';
        }
    },
    methods: {
        handleRemove() {
            this.$emit('remove', this.candidate);
        },
        handleClick() {
            this.$emit('click', this.candidate);
        }
    }
}
</script>

<template>
    <div class="mb-0 card card-border candidate f-flex flex-row align-items-center justify-content-start gap-3 position-relative bg-transparent" @click="handleClick">
        <button v-if="!isEmailLinked" @click.stop="handleRemove" class="btn btn-sm btn-circle bg-gray-300 text-black position-absolute btn-remove"><i class="fi fi-rr-cross-small"></i></button>
        <div class="d-flex justify-content-center my-1 image position-relative" >
            <avatar-image :src="image" wrapClass="border-radius-48"  classes="border-radius-48" width="50" height="50"/>
            <avatar-image v-if="spaceImage" :src="spaceImage" img-display="contain" wrap-class="border-radius-48 position-absolute bottom-0 right-0" classes="border-radius-48" width="20" height="20"/>
        </div>
        <div class="details">
            <p class="mb-0 label large username fw-bolder text-primary">{{ candidate.username }}</p>
            <small class="mb-0 label small second-identifier" >{{secondIdentifier}}</small>
        </div>
    </div>
</template>

<style scoped>
.candidate {
    cursor: pointer;
    border: 1px solid #E3E3E3;
    width: 100%;
    min-width: 240px;
}
.candidate:hover {
    transform: scale(1.05);
    transition: transform 0.3s;
}
.btn-remove {
    display: block;
}
.image {
    display: flex;
    justify-content: center;
    align-items: center;
}
.second-identifier, .username {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 200px;
}
.btn-remove {
    top: -10px;
    right: -10px;
    z-index: 1;
    height: 25px;
    width: 25px !important;
    min-width: 20px;
}

</style>
